import { Dispatch, useEffect, useState } from 'react';

export type UseSessionStorageProps<T> = [T, Dispatch<T>, (key: string) => void];

export default function useSessionStorage<T = any>(
  key: string,
  defaultValue: T,
  enabled: boolean = true,
): UseSessionStorageProps<T> {
  const [value, setValue] = useState<T>(() => {
    let currentValue: T;
    try {
      const item = sessionStorage.getItem(key);
      currentValue = item !== null ? JSON.parse(item) : defaultValue;
    } catch {
      currentValue = defaultValue;
    }
    return currentValue;
  });

  const removeItem = (removeKey: string) =>
    sessionStorage.removeItem(removeKey);

  useEffect(() => {
    if (enabled) {
      sessionStorage.setItem(key, JSON.stringify(value));
    }
    const hasSessionItem = !!sessionStorage.getItem(key);
    if (!enabled && hasSessionItem) {
      sessionStorage.removeItem(key);
    }
  }, [value, key, enabled]);

  return [value, setValue, removeItem];
}
